"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerController = void 0;
var dom_interact_1 = require("../helpers/dom-interact");
var tracker_1 = __importDefault(require("../helpers/tracker"));
var DeviceManager_1 = require("./DeviceManager");
var TrackingTypes_1 = require("../helpers/TrackingTypes");
var GA4BannerTracker_1 = require("./GA4/GA4BannerTracker");
var defaultConfiguration = {
    bannerHolder: '.category-teaser, .content-teaser',
    PADDINGS: 60,
    linkBlocks: '.links-item-wrap>ul',
    animatedSelector: 'animated',
    activeAnimation: 'is-running-animation',
    headlineBanner: '.js-headlines-block-link',
};
var BannerController = /** @class */ (function () {
    function BannerController(trackingCategory, config) {
        if (config === void 0) { config = defaultConfiguration; }
        this.config = config;
        this.deviceManager = new DeviceManager_1.DeviceManager();
        this.linksBlocks = document.querySelectorAll(this.config.linkBlocks);
        this.banners = document.querySelectorAll(this.config.bannerHolder);
        this.headlineBanners = document.querySelectorAll(this.config.headlineBanner);
        this.attachEvents();
        this.attachTrackingEvents(trackingCategory);
        this.setUpAnimationOnLinksBlocks();
    }
    BannerController.prototype.attachEvents = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            for (var i = 0; i < _this.banners.length; i++) {
                _this.adaptBannerHeightToImage(_this.banners[i]);
            }
            _this.setUpAnimationOnLinksBlocks();
        });
        var _loop_1 = function (i) {
            var imageInBanner = (0, dom_interact_1.getHTMLElement)(this_1.banners[i], 'picture img');
            (0, dom_interact_1.waitForImageLoad)(imageInBanner).then(function () {
                _this.adaptBannerHeightToImage(_this.banners[i], imageInBanner);
            });
        };
        var this_1 = this;
        for (var i = 0; i < this.banners.length; ++i) {
            _loop_1(i);
        }
        window.addEventListener('scroll', function () { return _this.animateLinkBlock(); });
    };
    BannerController.prototype.setUpAnimationOnLinksBlocks = function () {
        for (var i = 0; i < this.linksBlocks.length; i++) {
            var linksBlock = this.linksBlocks[i];
            if (this.shouldLinksBlockBeAnimated(linksBlock)) {
                linksBlock.classList.add(this.config.animatedSelector);
            }
            else {
                linksBlock.classList.remove(this.config.animatedSelector);
            }
        }
    };
    BannerController.prototype.shouldLinksBlockBeAnimated = function (el) {
        return this.deviceManager.getCurrentState() === DeviceManager_1.MOBILE && window.innerWidth < el.scrollWidth;
    };
    BannerController.prototype.animateLinkBlock = function () {
        var linksBlocksToAnimate = document.querySelectorAll(".".concat(this.config.animatedSelector));
        for (var i = 0; i < linksBlocksToAnimate.length; i++) {
            var linksBlock = linksBlocksToAnimate[i];
            var isBlockAnimated = linksBlock.classList.contains(this.config.activeAnimation);
            var isBlockInViewport = (0, dom_interact_1.isPartiallyInViewport)(linksBlock);
            var blockPositionLeft = linksBlock.getBoundingClientRect().left;
            if (isBlockInViewport && blockPositionLeft === 0 && !isBlockAnimated) {
                linksBlock.classList.add(this.config.activeAnimation);
            }
            else if (!isBlockInViewport && isBlockAnimated) {
                linksBlock.classList.remove(this.config.activeAnimation);
            }
        }
    };
    BannerController.prototype.adaptBannerHeightToImage = function (element, image) {
        if (!element.classList.contains('individual')) {
            var img = image || (0, dom_interact_1.getHTMLElement)(element, 'picture img');
            var target = (0, dom_interact_1.getHTMLElement)(element, '.w1');
            target.style.height = "".concat(img.offsetHeight - this.config.PADDINGS, "px");
        }
    };
    BannerController.prototype.attachTrackingEvents = function (trackingCategory) {
        var _this = this;
        var teaserTrackingLinks = document.querySelectorAll('.teaser-tracking-link');
        for (var i = 0; i < teaserTrackingLinks.length; i++) {
            teaserTrackingLinks[i].addEventListener('click', function (e) {
                e.preventDefault();
                var currentTarget = e.currentTarget;
                var trackingValue = currentTarget.getAttribute('data-tracking-value');
                var contentId = currentTarget.getAttribute('data-tracking-action') || '';
                var contentName = currentTarget.textContent || '';
                GA4BannerTracker_1.GA4BannerTracker.trackBannerClick({
                    block_section: "".concat(trackingCategory, " ").concat(TrackingTypes_1.TrackingData.ACTION_TEASER_CLICK),
                    block_index: trackingValue,
                    content_name: contentName,
                    content_id: contentId,
                });
                tracker_1.default.trackAndNavigate({
                    category: trackingCategory,
                    action: currentTarget.getAttribute('data-tracking-action'),
                    label: currentTarget.href,
                    value: trackingValue ? parseInt(trackingValue, 10) : undefined,
                }, currentTarget.href);
            });
        }
        for (var i = 0; i < this.headlineBanners.length; i++) {
            this.headlineBanners[i].addEventListener('click', function (e) {
                return _this.trackClickOnHeadlineBanner(e, trackingCategory);
            });
        }
    };
    BannerController.prototype.trackClickOnHeadlineBanner = function (event, trackingCategory) {
        var currentTarget = event.currentTarget;
        event.preventDefault();
        var trackingValue = currentTarget.getAttribute('data-tracking-value');
        var contentId = currentTarget.getAttribute('data-tracking-action') || '';
        var contentName = currentTarget.textContent || '';
        GA4BannerTracker_1.GA4BannerTracker.trackBannerClick({
            block_section: TrackingTypes_1.TrackingData.ACTION_HEADLINES_1_BANNER_CLICK,
            block_index: trackingValue,
            content_name: contentName,
            content_id: contentId,
        });
        tracker_1.default.trackAndNavigate({
            category: trackingCategory,
            action: TrackingTypes_1.TrackingData.ACTION_HEADLINES_1_BANNER_CLICK,
            label: currentTarget.href,
        }, currentTarget.href);
    };
    return BannerController;
}());
exports.BannerController = BannerController;
